import { EmploymentStatus } from '@zorro/clients';
import { getNow, tryParseDateISO } from '@zorro/shared/formatters';

import { logger } from './logger';

export const getEmployeeEmploymentStatus = (
  employeeId: string,
  eligibleFrom?: string | null,
  eligibleUntil?: string | null,
  leaveOfAbsenceStartDate?: string | null,
  leaveOfAbsenceEndDate?: string | null,
  terminationDate?: string | null
  // eslint-disable-next-line sonarjs/cognitive-complexity
): EmploymentStatus | null => {
  const now = getNow();
  const parsedEligibleFrom = tryParseDateISO(eligibleFrom);
  const parsedEligibleUntil = tryParseDateISO(eligibleUntil);
  const parsedTerminationDate = tryParseDateISO(terminationDate);
  const parsedLeaveOfAbsenceStartDate = tryParseDateISO(
    leaveOfAbsenceStartDate
  );
  const parsedLeaveOfAbsenceEndDate = tryParseDateISO(leaveOfAbsenceEndDate);

  if (parsedEligibleUntil?.isBefore(now, 'day')) {
    return parsedTerminationDate?.isBefore(now, 'day')
      ? EmploymentStatus.INELIGIBLE_TERMINATED
      : EmploymentStatus.INELIGIBLE;
  }

  if (
    parsedLeaveOfAbsenceStartDate?.isSameOrBefore(now, 'day') &&
    parsedLeaveOfAbsenceEndDate?.isSameOrAfter(now, 'day')
  ) {
    return EmploymentStatus.INELIGIBLE_ON_LEAVE;
  }

  if (!parsedEligibleFrom || parsedEligibleFrom.isSameOrBefore(now, 'day')) {
    if (!parsedEligibleUntil) {
      const hasUpcomingLeave =
        parsedLeaveOfAbsenceStartDate &&
        parsedLeaveOfAbsenceEndDate &&
        parsedLeaveOfAbsenceStartDate.isAfter(now, 'day');
      return hasUpcomingLeave
        ? EmploymentStatus.ELIGIBLE_UPCOMING_LEAVE
        : EmploymentStatus.ELIGIBLE_EMPLOYED;
    }
    if (parsedEligibleUntil.isSameOrAfter(now, 'day')) {
      return EmploymentStatus.ELIGIBLE_ENDING;
    }
  }

  if (
    parsedEligibleFrom &&
    parsedEligibleUntil &&
    parsedEligibleFrom.isAfter(parsedEligibleUntil, 'day')
  ) {
    return EmploymentStatus.INELIGIBLE;
  }

  if (parsedEligibleFrom?.isAfter(now, 'day')) {
    return EmploymentStatus.INELIGIBLE_WAITING;
  }

  logger.error(
    `Could not determine employee employment status for employee ${employeeId}`
  );
  return null;
};
